import * as React from 'react';
import { FilterDataReturn } from '../HotelsLeftSide';
import { HotelSearchResultWithUrlReqKeyMainPanel, FilterSelected, CurrenSelectedFilter } from '../HotelSearchResultWithUrlReqKeyMainPanel';
import { HotelBedData } from 'src/shared';
import { bandingkanArray, kuraingArray } from './bandingkanArray';

export function filterFacilitiesHotel(Facilities: FilterDataReturn[], getAvailabilityDetailFiltered: (hotelCodes: number[], externalFilter: HotelBedData.ExternalFilter) => any, panel: HotelSearchResultWithUrlReqKeyMainPanel, filterSelected: FilterSelected, currenSelectedFilter: CurrenSelectedFilter) {

    let ret: any[] = [];
    let selected: string[] = ['Swim-up bar', 'Kids’ club', 'Private Pool', 'Meeting room'];
    for (let fil of Facilities) {
        let style = {};
        let icon = <i className="ti-layout-width-full"/>;
        let curSelect = filterSelected; // new code
        let current: boolean = false;   // new code
        if (curSelect.Facilities.indexOf(fil.description) > -1) {
            style = { background: '#666' };
            icon = <i className="ti-check-box"/>;
            current = true; // new code 
        }
        if (selected.indexOf(fil.description) > -1) {
            ret.push(
                <li>
                    <a
                        style={style}
                        onClick={
                            () => {
                                let desFilter = curSelect.Facilities; // new code 
                                let htCodes = fil.hotelCodes;
                                let htC: number[] = [];
                                for (let f of Object.keys(currenSelectedFilter)) {
                                    if (f !== "Facilities") {
                                        htC = bandingkanArray(htC, currenSelectedFilter[f]);
                                    }
                                }
                                // let curSelect = filterSelected;  di hapus
                                if (!current) {
                                    htCodes.push(...currenSelectedFilter.Facilities);
                                    currenSelectedFilter.Facilities = htCodes; 
                                    htCodes = bandingkanArray(htCodes, htC); 
                                    // desFilter.push(fil.description);
                                    desFilter += fil.description;
                                    curSelect.Facilities = desFilter;
                                } else {
                                    let x = desFilter;
                                    let y = fil.description;
                                    let b = x.replace(y, '');
                                    curSelect.Facilities = b;
                                    let n = currenSelectedFilter.Facilities;
                                    console.log("htCodes", n);
                                    let m = fil.hotelCodes;
                                    console.log("htCodes", m);
                                    let o = kuraingArray(n, m);
                                    console.log("htCodes", o);
                                    currenSelectedFilter.Facilities = o; 
                                    htCodes = bandingkanArray(o, htC);
                                }
                                panel.setState({ facilities: fil.description, page: 0, hotelCodesFilter: htCodes, currenSelectedFilter, filterSelected: curSelect }, () => { getAvailabilityDetailFiltered(htCodes, {}); });
                            }
                        }
                    > {icon} {fil.description}
                    </a>
                </li>
            );
        }

    }
    return (
        <div className="btn-group" style={{ border: '1px solid #fff' }} >
            <a href="javascript:void(0)" data-toggle="dropdown" style={{ color: "#fff" }} className="btn btn-squared btn-primary  dropdown-toggle" aria-expanded="true">
                Facilities   <span className="caret" />
            </a>
            <ul className="dropdown-menu dropdown-dark pull-right" role="menu">
                {ret}
            </ul>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/hotels/hotel-top-filter/filterFacilitiesHotel.tsx